<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useDecisionSupportWizardStore } from '../../stores/decision-support-wizard.store';
import { WizardOverviewParcelCard } from '@shared';
import DecisionSupportWizardOverviewParcel from './DecisionSupportWizardOverviewParcel.vue';

const decisionSupportWizardStore = useDecisionSupportWizardStore();
const { decisionSupportData, isUiDisabled, isSaveValid, isSaving } = storeToRefs(decisionSupportWizardStore);
</script>

<template>
  <div class="h-100 d-flex flex-column">
    <div class="flex-grow-0">
      <v-card
        variant="flat"
        :title="$t('decisionSupport.wizard.step.overview')" />
    </div>
    <div class="flex-grow-1 position-relative mt-4 mb-4">
      <div
        class="h-100 position-absolute d-flex flex-column align-content-lg-space-between overflow-x-hidden gap-1 pl-4 pr-4 pb-4 pt-1"
        style="top: 0; left: 0; right: 0; bottom: 0; overflow-y: scroll">
        <transition-group name="application-data-items">
          <wizard-overview-parcel-card
            v-for="parcel in decisionSupportData.parcels"
            :key="parcel.id"
            :parcel="parcel"
            :module-class-name="'decision-support'">
            <template #item>
              <decision-support-wizard-overview-parcel :parcel="parcel" />
            </template>
          </wizard-overview-parcel-card>
        </transition-group>
      </div>
    </div>
    <div class="flex-grow-0 pa-4 text-center">
      <v-text-field
        v-model="decisionSupportData.name"
        :label="$t('decisionSupport.wizard.label.decisionSupportName')"
        :disabled="isUiDisabled"
        variant="outlined"
        density="compact"
        :hide-details="true"
        @update:model-value="decisionSupportWizardStore.validateDecisionSupportSave"
        @blur="decisionSupportWizardStore.validateDecisionSupportSave" />
      <v-btn
        color="primary"
        class="mt-4"
        :loading="isSaving"
        :disabled="isUiDisabled || !isSaveValid"
        @click.prevent.stop="decisionSupportWizardStore.saveDecisionSupport">
        {{ $t('decisionSupport.wizard.label.saveDecisionSupport') }}
      </v-btn>
    </div>
  </div>
</template>
